exports.signDocument = (state, event) => state.dal.document.saveEvent(state, event)
